export const STORAGE_PREFIX = 'monospace-studio';

export function storageKey(name: string): string {
	return `${STORAGE_PREFIX}:${name}`;
}
